import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Renderer,
    Renderer2,
    ViewChild,
    AfterViewInit,
} from '@angular/core';
import { map } from 'rxjs/operators';
import { OddConstant } from '~/constant/odd.constant';
import { translationHelper } from '~/helpers/translation.helper';

import { uiHelper } from '~/helpers/ui.helper';
import { FixtureModel } from '~/legacy/ts/categories/categories';
import { Login } from '~/legacy/ts/login/login';
import { LoginService } from '~/legacy/ts/login/services/login.service';
import { CoreService } from '~/legacy/ts/services/core.service';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { DATA_INITIALIZER } from '~/constant/sports.constant';
import { lg } from '~/modules/colorLog';
import { ElectronService } from 'ngx-electron';
import { fromEvent, merge, of, Subscription } from 'rxjs';
import { TryCatch } from '@sentry/browser/dist/integrations';
import { Title } from '@angular/platform-browser';
import { stat } from 'fs';
import { environment } from '@env/environment';

declare let $;
declare let _sendChromeMessage: any;

declare let appWindow: any;
declare let appOrigin: any;

@Component({
    selector: 'comp_corecomponent',
    templateUrl: './core.component.html',
})
export class CoreComponent implements OnInit {
    @ViewChild(Login, { static: false }) public childLogin: Login;
    public SecondScreenIsActive = false;
    public flag = 0;
    public stopListening: Function;
    public flag_initialmoney = 0;

    public init: boolean;

    loadingIsActive = false;

    ALLOWED_TO_START = false;

    constructor(
        public loginService: LoginService,
        private coreService: CoreService,
        private renderer: Renderer,
        private http: HttpClient,
        private location: Location,
        public _uiHelper: uiHelper,
        private _translationHelper: translationHelper,
        private _OddConstant: OddConstant,
        public tournamentsService: TournamentsService,
        private _ElectronService: ElectronService,
        private titleService: Title,
    ) {
        this.Page_Size_Optimization();

        //todo listener
        const tconfigfromStorage = localStorage.getItem('tconfig');
        if (tconfigfromStorage != null) {
            this._uiHelper.SetTerminalConfig(JSON.parse(tconfigfromStorage));
        }

        this.stopListening = this.renderer.listen('window', 'message', this.handleMessage.bind(this));
        let resConfig = this.http
            .get('/API/' + 'GetClientSetting/')
            .pipe(map((response: Response) => (response as unknown) as []))
            .subscribe(
                resConfig => {
                    let sportData;
                    let oddData;
                    let translateData;

                    try {
                        if (resConfig['terminalConfig']) {
                            this._uiHelper.SetTerminalConfig(resConfig['terminalConfig']);
                            //  this._uiHelper.SetTerminalConfig({IsBetOn: true,
                            //    IsCashout: true,
                            //    IsLiveOn: true,
                            //    IsSportOn: true,
                            //    ShowCashoutButton: true,
                            //    TemporaryBet: true,
                            //    TerminalCongId: 1,
                            //    TerminalId: 41001})
                        }

                        resConfig['settings'].forEach(item => {
                            item['Types'] === 'Odd' ? (oddData = JSON.parse(item['Data'])) : null;
                            sportData = [
                                {
                                    name: 'Soccer',
                                    tName: 'Soccer',
                                    EnumSportType: 1,
                                    icon: 'sport-icons/football.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Basketball',
                                    tName: 'BasketballOT',
                                    EnumSportType: 2,
                                    icon: 'sport-icons/basketball.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Volleyball',
                                    tName: 'Volleyball',
                                    EnumSportType: 20,
                                    icon: 'sport-icons/volleyball.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Tennis',
                                    tName: 'Tennis',
                                    EnumSportType: 5,
                                    icon: 'sport-icons/tennis.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Ice Hockey',
                                    tName: 'Ice_Hockey',
                                    EnumSportType: 4,
                                    icon: 'sport-icons/hockey.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Handball',
                                    tName: 'Handball',
                                    EnumSportType: 6,
                                    icon: 'sport-icons/handball.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'American Football',
                                    tName: 'americanFootbal',
                                    EnumSportType: 14,
                                    icon: 'sport-icons/rugby.png',
                                    sportEventCount: 0,
                                },

                                {
                                    name: 'Baseball',
                                    tName: 'baseball',
                                    EnumSportType: 3,
                                    icon: 'sport-icons/baseball.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Winter Sports',
                                    tName: 'wintersports',
                                    EnumSportType: 12,
                                    icon: 'sport-icons/winter.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Darts',
                                    tName: 'darts',
                                    EnumSportType: 19,
                                    icon: 'sport-icons/dart.png',
                                    sportEventCount: 0,
                                },
                                {
                                    name: 'Boxing',
                                    tName: 'boxing',
                                    EnumSportType: 35,
                                    icon: 'sport-icons/boxing.png',
                                    sportEventCount: 0,
                                },
                            ];

                            item['Types'] === 'Lang' ? (translateData = JSON.parse(item['Data'])) : null;
                        });

                        let promise: [Promise<any>, Promise<any>] = [
                            this._translationHelper.DATA_INITIALIZER(translateData),
                            DATA_INITIALIZER(sportData),
                        ];
                        Promise.all(promise).then(res => {
                            this._OddConstant
                                .DATA_INITIALIZER({ oddData, forbiddenOddTypes: resConfig['forbiddenOddTypes'] })
                                .then(() => {
                                    if (
                                        resConfig['terminalConfig'] &&
                                        resConfig['terminalConfig'].IsOnlyDeposit === true
                                    ) {
                                        if (
                                            !(
                                                this.location.prepareExternalUrl(this.location.path()) ==
                                                    '/secondscreen' ||
                                                this.location.prepareExternalUrl(this.location.path()) ==
                                                    '/SecondScreen' ||
                                                this.location.prepareExternalUrl(this.location.path()) ==
                                                    '/secondScreen'
                                            )
                                        ) {
                                            lg('INIT', 'IS ONLY DEPOSIT CLIENT');
                                            this._uiHelper.setOnlyDeposit(true);
                                            this.STARTUP();
                                            this.ALLOWED_TO_START = true;
                                            lg('INIT', 'ALL COMPLETED DEPOSIT');

                                            return;
                                        }
                                        return;
                                    }

                                    this.STARTUP();
                                    this.ALLOWED_TO_START = true;
                                    this.tournamentsService.SERVICE_STARTUP.emit(true);
                                    lg('INIT', 'ALL COMPLETED');
                                });
                        });
                    } catch (e) {
                        console.error(e);
                    }
                },
                error => {
                    this._uiHelper.SendElectronMessage('electronListener', {
                        type: 'internetconnection',
                        status: false,
                        tid: this.titleService.getTitle(),
                    });
                },
            );
        this.checkNetworkStatus();
    }

    public refreshAPP() {
        location.reload();
    }

    public ngOnInit() {
        if (this.init) {
            return;
        }
        this.init = true;
        // _sendChromeMessage("runmoneyreader");
    }

    ngAfterViewInit() {
        this.checkElectron();
    }

    @HostListener('window:resize')
    public onResize() {
        this.Page_Size_Optimization();
    }

    STARTUP() {
        const comp = this as CoreComponent;
        if (this._uiHelper.terminalConfig && Object.keys(this._uiHelper.terminalConfig).length > 0) {
            this.coreService.configureClient();
        }

        this.SecondScreenIsActive = this._uiHelper.scoreBoxView;
        this._uiHelper.scoreBoxViewListener.subscribe(x => {
            this.SecondScreenIsActive = x;
        });

        $(document).scannerDetection({
            timeBeforeScanTest: 200, // wait for the next character for upto 200ms
            avgTimeByChar: 40, // it's not a barcode if a character takes longer than 100ms
            preventDefault: true,

            endChar: [13],
            onComplete(barcode, qty) {
                // console.log("Barcode ", barcode);
                comp.parseBarcode(barcode + ' ');
            }, // main callback function	,
            onError(string, qty) {
                // console.log("Barcode error");
            },
        });
        const currentPath = this.location.prepareExternalUrl(this.location.path());
        const secondScreenPaths = ['/SecondScreen', '/secondscreen', '/ScoreBox', '/secondScreen'];

        if (secondScreenPaths.indexOf(currentPath) !== -1) {
            this.SecondScreenIsActive = true;
            this._uiHelper.SecondScreenIsActive = true;
            this.checkScoreBoxElectron();
            // this.tournamentsService._allscreenheader = 1;
        } else {
            this.SecondScreenIsActive = false;
            this._uiHelper.SecondScreenIsActive = false;
            // this.tournamentsService._allscreenheader = 0;
        }

        this._uiHelper.refreshAppListener.subscribe(x => {
            this.refreshAPP();
        });
    }

    public handleMessage(event: Event) {
        // console.log("##event", event);
        // window.postMessage({"command":"moneyread","stake":20},"*")
        // window.postMessage({"command":"cardinserted","message":1340},"*")
        const message = event as MessageEvent;
        if (!appWindow || !appOrigin) {
            appWindow = message.source;
            appOrigin = message.origin;

            this.checkElectron();

            // console.log("##_receiveChromeMessage_appWindow", appWindow);
            // console.log("##_receiveChromeMessage_appOrigin", appOrigin);

            // _sendMessage({
            //    command: 'handshakereply'
            // });
            _sendChromeMessage({
                command: 'connectdevices',
            });
        } else {
            this.checkElectron();
        }

        // Only trust messages from the below origin.
        // if (message.origin !== 'http://example.com:8080') return;

        // console.log("MESSAGE", message.data);

        if (message.data.command == 'slipread') {
        } else if (message.data.command == 'barcoderead') {
            const BarcodeNumber = message.data.slip;
            this.parseBarcode(BarcodeNumber);
        } else if (message.data.command == 'moneyread') {
            let money = message.data.stake.toString();

            console.log('Money_READ', money.toString());

            this.tournamentsService.MoneyTransaction(money);

            this.tournamentsService.Terminal_Balance_Change(
                money,
                'increase',
                $('input[name="__RequestVerificationToken"]').val(),
            );
        } else if (message.data.command == 'moneysystem') {
            // console.log("Money_SISTEM");
        } else if (message.data.command == 'cardinserted') {
            // console.log("CustomerId", message.data.message);

            if (message.data.message.toString() != 'removed') {
                this.LoadingOpenandClose();

                const CustomerIdString = message.data.message.toString();

                // Bazı Terminallerde PIN sorulmadan giriş yapılabilecek
                if (this._uiHelper.terminalConfig.IsPINActive) {
                    this.tournamentsService.DecryptString(CustomerIdString).then((x: any) => {
                        this.checkBarcodeCardIsFirstLogin(x, false);
                    });
                } else {
                    this.coreService.customerUser.CustomerId = CustomerIdString;
                    this.coreService.CustomerCardBalance2(CustomerIdString);
                }

                //Open Customer Transcation Summary Window
                if (environment.systemName === 'wettarena') {
                    $('#Transactions_Modal').modal('show');
                    this._uiHelper.SetTransactionModal(true);
                }
                //Open Customer Transcation Summary Window
            } else {
                $('#Transactions_Modal').modal('hide');
                $('#BarcodeCardModal').modal('hide');
                this.coreService.customerUser.CustomerId = '';
                this.LoadingOpenandClose();
                // Kart çıkartıldığında

                this._uiHelper.SetCustomerCardStatus(false);

                // Bu Terminal in Müştersisi değil
                if (
                    this.coreService.customerUser != undefined &&
                    this.coreService.customerUser.CustomerCardActiveControl == '1'
                ) {
                    console.log(
                        '--haltmoneyreader2 --- reopen --- Kart Takıldı --- Bu Terminal in Müştersisi değil --- PARA OKUMA AÇILDI --',
                    );

                    // PARA OKUMA AÇILDI

                    if (
                        this._uiHelper.terminalConfig.TemporaryBet == true &&
                        this._uiHelper.terminalConfig.IsBetOn == true
                    ) {
                        console.log(
                            '-- CHROME --haltmoneyreader2 --- reopen --- Kart çıkartıldı --- Bu Terminal in Müştersisi değil --- PARA OKUMA AÇILDI --',
                        );

                        // PARA OKUMA AÇILDI 04.04.2022
                        _sendChromeMessage({
                            command: 'haltmoneyreader2',
                        });

                        this._uiHelper.SendElectronMessage('electronListener', {
                            type: 'moneyReader_control',
                            money_reader_status: 'reopen',
                        });
                    }
                }

                // Bu Terminal in Müştersisi
                if (this.coreService.customerUser.CustomerCardActiveControl == '0') {
                    if (
                        this._uiHelper.terminalConfig.TemporaryBet == false ||
                        this._uiHelper.terminalConfig.IsBetOn == false
                    ) {
                        console.log(
                            '-- CHROME --haltmoneyreader --- disable --- Kart çıkartıldı --- Bu Terminal in Müştersisi --- PARA OKUMA KAPATILDI --',
                        );

                        // PARA OKUMA KApatıldı 04.04.2022
                        _sendChromeMessage({
                            command: 'haltmoneyreader',
                        });

                        this._uiHelper.SendElectronMessage('electronListener', {
                            type: 'moneyReader_control',
                            money_reader_status: 'disable',
                        });
                    }
                }

                this.coreService.SignOutCard();

                //this.tournamentsService.router.navigate(['/LiveBets']);
                // comp.tournamentsService.router.navigate(['/LiveBets']);
            }
            // this.tournamentsService.cardCustomerId = message.data.message.toString();
            // $('#CardCustomerId').modal({
            //    allowMultiple: true,
            //    closable: false

            // }).modal('show');
        } else if (message.data.command == 'credentialsun') {
            this.loginService.credentialsun = message.data.username.toString();
        } else if (message.data.command == 'credentialspw') {
            this.loginService.credentialspw = message.data.pwd.toString();
            if (this.childLogin != undefined) {
                this.childLogin.autoSignIn();
	
            }
        }
    }
    flagCheckElectron = false;
    public checkElectron() {
        if (this._ElectronService.isElectronApp && !this.flagCheckElectron) {
            console.warn('checkElectron');
            this.flagCheckElectron = true;
            if (this._ElectronService.ipcRenderer != null) {
                this._ElectronService.ipcRenderer.on('angularListener', (event, arg) => {
                    if (arg && arg.type === 'money_read') {
                        console.log('Money_READ', arg);

                        let money = arg.amount;

                        this.tournamentsService.MoneyTransaction(money);
                        this.tournamentsService.Terminal_Balance_Change(
                            money,
                            'increase',
                            $('input[name="__RequestVerificationToken"]').val(),
                        );
                    } else if (arg && arg.type === 'money_read_check') {
                        console.log('Money_READ', arg);

                        const money = arg.amount;
                        const transaction_id = arg.transaction_id;
                        this.tournamentsService.MoneyTransaction(money);

                        this.tournamentsService.Terminal_Balance_Change_Electron(
                            money,
                            'increase',
                            transaction_id,
                            $('input[name="__RequestVerificationToken"]').val(),
                        );
                    } else if (arg && arg.type === 'creditLog') {
                        //try {
                        //  this.tournamentsService.CreditLogger(arg.creditData);
                        //} catch (e) {
                        //  console.log(e);
                        //}
                    } else if (arg && arg.type === 'firstlogin') {
                        try {
                            console.warn('Trying to login (core)...(' + arg.username.toString() + ')');

                            // Prevent duplicate emits if already logged in
                            if (this.loginService.LoginState === 1) {
                                return;
                            }

                            if (arg.username.toString() != undefined && arg.password.toString() != undefined) {
                                if (arg.username.toString() != '' && arg.password.toString() != '') {
                                    this.loginService.firstLoginReceived.emit(arg);
                                    setTimeout(() => {
                                        if (this.loginService.LoginState !== 1) {
                                            this.loginService.firstLoginReceived.emit(arg);
                                        }
                                    }, 10000);
                                } else {
                                    return;
                                }
                            }
                        } catch (e) {
                            console.log(e);
                        }
                    }
                    if (arg && arg.type === 'cardinserted') {
                        //console.warn(arg);
                        if (arg.message != undefined) {
                            if (arg.message.toString() != 'removed') {
                                console.log('ELECTRON- KART TAKILDI');

                                this.LoadingOpenandClose();

                                const CustomerIdString = arg.message.toString();

                                // Bazı Terminallerde PIN sorulmadan giriş yapılabilecek
                                if (this._uiHelper.terminalConfig.IsPINActive) {
                                    this.tournamentsService.DecryptString(CustomerIdString).then((x: any) => {
                                        this.checkBarcodeCardIsFirstLogin(x, false);
                                    });
                                } else {
                                    console.log(CustomerIdString);
                                    this.coreService.customerUser.CustomerId = CustomerIdString;
                                    this.coreService.CustomerCardBalance2(CustomerIdString);
                                }
                                //Show Trancation Summary to Customer
                                console.warn('Transcation Modal triggered');
                                $('#Transactions_Modal').modal('show');
                                this._uiHelper.SetTransactionModal(true);
                                //Show Trancation Summary to Customer
                            } else {
                                $('#Transactions_Modal').modal('hide');
                                $('#BarcodeCardModal').modal('hide');
                                console.log('ELECTRON- KART ÇIKARILDI');
                                this.coreService.customerUser.CustomerId = '';
                                this.LoadingOpenandClose();

                                this._uiHelper.SetCustomerCardStatus(false);

                                // Kart çıkartıldığında
                                // Bu Terminal in Müştersisi değil

                                if (
                                    this.coreService.customerUser != undefined &&
                                    this.coreService.customerUser.CustomerCardActiveControl == '1'
                                ) {
                                    // PARA OKUMA AÇILDI

                                    if (
                                        this._uiHelper.terminalConfig.TemporaryBet == true &&
                                        this._uiHelper.terminalConfig.IsBetOn == true
                                    ) {
                                        console.log(
                                            '-- ELECTRON --haltmoneyreader2 --- reopen --- Kart çıkartıldı --- Bu Terminal in Müştersisi değil --- PARA OKUMA AÇILDI --',
                                        );

                                        // PARA OKUMA AÇILDI 04.04.2022
                                        _sendChromeMessage({
                                            command: 'haltmoneyreader2',
                                        });

                                        this._uiHelper.SendElectronMessage('electronListener', {
                                            type: 'moneyReader_control',
                                            money_reader_status: 'reopen',
                                        });
                                    }
                                }

                                // Bu Terminal in Müştersisi
                                if (this.coreService.customerUser.CustomerCardActiveControl == '0') {
                                    if (
                                        this._uiHelper.terminalConfig.TemporaryBet == false ||
                                        this._uiHelper.terminalConfig.IsBetOn == false
                                    ) {
                                        console.log(
                                            '-- ELECTRON --haltmoneyreader --- disable --- Kart çıkartıldı --- Bu Terminal in Müştersisi --- PARA OKUMA KAPATILDI --',
                                        );

                                        // PARA OKUMA KApatıldı 04.04.2022
                                        _sendChromeMessage({
                                            command: 'haltmoneyreader',
                                        });

                                        this._uiHelper.SendElectronMessage('electronListener', {
                                            type: 'moneyReader_control',
                                            money_reader_status: 'disable',
                                        });
                                    }
                                }
                                this.coreService.SignOutCard();
                            }
                        }
                    }
                });
            }
        }
    }

    public checkScoreBoxElectron() {
        //geçici olarak kapatıldı
        return;
        if (this._ElectronService.isElectronApp) {
            console.warn('checkElectron ScoreBox');
            if (this._ElectronService.ipcRenderer != null) {
                this._ElectronService.ipcRenderer.on('angularListener', (event, arg) => {
                    if (arg && arg.type === 'livetracker') {
                        //console.log('livetracker', arg);

                        if (arg.isopen) {
                            this._uiHelper.setLiveTrackerModalParameter(arg.matchid);
                            let timeFunc;
                            $('#Livetracker_Modal').modal('hide');
                            $('#Livetracker_Modal')
                                .modal({
                                    detachable: false,

                                    onShow: function() {
                                        timeFunc = setTimeout(() => {
                                            $('#Livetracker_Modal').modal('hide');
                                        }, 120000);
                                    },

                                    onHidden: function() {
                                        clearTimeout(timeFunc);
                                        if (this._uiHelper != undefined) this._uiHelper.LivetrackerModalClose(true);
                                    },
                                })
                                .modal('show');
                        }
                    }
                });
            }
        }
    }

    public parseBarcode(BarcodeNumber) {
        const BarCode = BarcodeNumber.split(' ')[0];
        const BarCodeString = String(BarCode);
        const BarcodeLength = BarCodeString.length;
        const firstCode = BarCodeString.substring(0, 3);
        const PIN = BarCodeString.substring(BarcodeLength - 3, BarcodeLength);
        const SlipID = BarCodeString.substring(3, BarcodeLength - 3);
        const BarcodeCustomer = BarCodeString.substring(3, BarcodeLength);

        this.tournamentsService.PayoutSlipNumber = SlipID;
        this.tournamentsService.PayoutSlipPassword = PIN;

        if (firstCode == '100') {
            this.tournamentsService.ticket_Slip_Password_Control(SlipID, PIN);
        } else if (firstCode == '200') {
            if (this._uiHelper.isAdminScreenVisible && this._uiHelper.adminScreenState === 2) {
                this.tournamentsService.payoutPayConfirmButton = 1;
                this.tournamentsService.payoutSlipPay($('input[name="__RequestVerificationToken"]').val());
            }
        } else if (firstCode == '214') {
            // Barcode Card => 214 ile Başlayan Kartlar
            this._uiHelper.CardNoCheck(BarcodeCustomer).then((x: boolean) => {
                if (x) {
                    this.checkBarcodeCardIsFirstLogin(BarCode, true);
                } else {
                    console.error('INVALID CARD');
                }
            });
        } else if (firstCode == '500') {
            // VorabTicket => 500 ile Başlayan QR Kodları
            // VorabTicket için PIN kullanmıyoruz, sadece 500'den sonraki kısmı alıyoruz
            const VorabSlipID = BarCodeString.substring(3).replace('ö', '').replace(',', ''); // 500'den sonraki tüm kısım
            this.tournamentsService.vorabTicket_Terminal(VorabSlipID, $('input[name="__RequestVerificationToken"]').val());
        }
    }

    public ngOnDestroy() {
        this.stopListening();
    }

    public Page_Size_Optimization() {
        this.tournamentsService.Page_Window_Height = window.innerHeight;
        this.tournamentsService.Page_Window_Width = window.innerWidth;
        // console.log("Page_Window_Height", this.tournamentsService.Page_Window_Height);
        // console.log("Page_Window_Width", this.tournamentsService.Page_Window_Width);
    }

    LoadingOpenandClose() {
        this.loadingIsActive = true;

        setTimeout(() => {
            // <<<---using ()=> syntax
            this.loadingIsActive = false;
        }, 1000);
    }

    flagcheckNetworkStatus = false;
    checkNetworkStatus() {
        navigator.onLine;
        merge(of(null), fromEvent(window, 'online'), fromEvent(window, 'offline'))
            .pipe(map(() => navigator.onLine))
            .subscribe(status => {
                //console.warn("internetconnection", status);
                //console.warn("internetconnection TemporaryBet", this._uiHelper.terminalConfig.TemporaryBet);
                //console.warn("internetconnection IsBetOn", this._uiHelper.terminalConfig.IsBetOn);

                this._uiHelper.SendElectronMessage('electronListener', {
                    type: 'internetconnection',
                    status: status,
                    tid: this.titleService.getTitle(),
                });

                if (status && this.flagcheckNetworkStatus) {
                    setTimeout(() => {
                        //console.warn("internetconnection --------", this._uiHelper.terminalConfig.TemporaryBet);
                        //console.warn("internetconnection TemporaryBet", this._uiHelper.terminalConfig.TemporaryBet);
                        //console.warn("internetconnection IsBetOn", this._uiHelper.terminalConfig.IsBetOn);
                        if (
                            this._uiHelper.terminalConfig.TemporaryBet == false ||
                            this._uiHelper.terminalConfig.IsBetOn == false
                        ) {
                            //console.warn(
                            //    'internetconnection moneyReader_control disable',
                            //    this._uiHelper.terminalConfig.IsBetOn,
                            //);
                            this._uiHelper.SendElectronMessage('electronListener', {
                                type: 'moneyReader_control',
                                money_reader_status: 'disable',
                            });
                        } else {
                            //console.warn(
                            //    'internetconnection moneyReader_control enable',
                            //    this._uiHelper.terminalConfig.IsBetOn,
                            //);
                            this._uiHelper.SendElectronMessage('electronListener', {
                                type: 'moneyReader_control',
                                money_reader_status: 'enable',
                            });
                        }
                    }, 2000);
                } else {
                    this.flagcheckNetworkStatus = true;
                }
            });
    }

    checkBarcodeCardIsFirstLogin(barcode = '', IsBarcodeCard = false) {
        this.tournamentsService.ProcCustomerBarcodeSearchTerminalResult(barcode, IsBarcodeCard).then((x: any) => {
            // console.log('checkBarcodeCardIsFirstLogin', x);
        });
    }
}
